/* TwoTierLayoutRenderer.js */

'use strict';

const _ = require('lodash');
const HorizontalNavComponent = require('./horizontalnavcomponent/HorizontalNavComponent');

class TwoTierLayoutRenderer {
  constructor(model, logger) {
    this._model = model;
    this._logger = logger;

    this._rootElem = document.createElement('two-tier-layout-gl');
    this._rootElem.component = this._model;

    this._groupNavCmpnt = new HorizontalNavComponent();
    this._groupNavCmpnt.renderer.getRootElement().classList.add('group-nav');

    this._pageNavCmpnt = new HorizontalNavComponent();
    this._pageNavCmpnt.renderer.getRootElement().classList.add('page-nav');

    this._pageContainer = document.createElement('page-container-gl');
    this._pageComponent = null;

    this._registerListeners();
  }
  /********************************************/
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /********************************************/
  _shutdown() {
    this._unregisterListeners();
    this._model = undefined;
    this._rootElem.remove();
    this._rootElem = undefined;
    return Promise.resolve();
  }
  _registerListeners() {
    this._model.on('Shutdown', (this._onShutdown = this._onShutdown.bind(this)));
    this._model.on('OrganizationChanged', (this._orgChanged = this._orgChanged.bind(this)));
    this._model.on(
      'LicensesUpdated',
      (this._onLicensesUpdated = this._onLicensesUpdated.bind(this))
    );
    this._groupNavCmpnt.on('NavItemSelected', (this._selectGroup = this._selectGroup.bind(this)));
    this._pageNavCmpnt.on('NavItemSelected', (this._selectPage = this._selectPage.bind(this)));
  }
  _unregisterListeners() {
    this._model.removeListener('Shutdown', this._onShutdown);
    this._model.removeListener('LicensesUpdated', this._onLicensesUpdated);
  }
  _selectGroup(oldName, name) {
    this.model.selectedGroup = name;
  }
  _selectPage(oldName, name) {
    this.model.selectedPage = name;
  }
  _orgChanged(orgObj) {
    if (this._pageComponent && this._pageComponent.organizationChanged) {
      this._pageComponent.organizationChanged(orgObj);
    }
  }

  _onLicensesUpdated() {
    this._renderNavigation();
  }

  _clearPageComponent() {
    if (this._pageComponent) {
      this._pageComponent.shutdown();
    }
    this._pageComponent = null;
  }
  _renderGroupNavOptions() {
    let nameList = [];
    let groupNavOptions = [];

    //Add unique groupRouteNames to list & options
    this.model.pageParts.forEach((pagePart) => {
      if (nameList.indexOf(pagePart.groupRouteName) === -1) {
        nameList.push(pagePart.groupRouteName);
        groupNavOptions.push({label: pagePart.groupName, value: pagePart.groupRouteName});
      }
    });

    this._groupNavCmpnt.setNavOptions(groupNavOptions);
  }
  _renderPageNavOptions() {
    let groupRouteName = this.model.selectedGroup;
    let pageNavOptions = [];

    this.model.pageParts.forEach((pagePart) => {
      if (pagePart.groupRouteName === groupRouteName) {
        pageNavOptions.push({label: pagePart.displayName, value: pagePart.pageRouteName});
      }
    });

    this._pageNavCmpnt.setNavOptions(pageNavOptions);
  }
  _renderPageContainer() {
    this._clearPageComponent();
    let pagePartObj = this.model.pageParts.find((obj) => {
      return (
        obj.pageRouteName === this.model.selectedPage &&
        obj.groupRouteName === this.model.selectedGroup
      );
    });
    this._pageComponent = this.model.createItem(pagePartObj.moduleName);
    this._pageContainer.appendChild(this._pageComponent.renderer.getRootElement());
    if (this._pageComponent && this.model.pageData && _.isFunction(this._pageComponent.setData)) {
      this._pageComponent.setData(this.model.pageData);
    }
    return this._pageComponent.renderer.render();
  }
  /*******************************************/
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /*******************************************/
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    if (!this._rootElem.hasChildNodes()) {
      this._rootElem.appendChild(this._groupNavCmpnt.renderer.getRootElement());
      this._rootElem.appendChild(this._pageNavCmpnt.renderer.getRootElement());
      this._rootElem.appendChild(this._pageContainer);
    }
    this._renderNavigation();
    return this._renderPageContainer();
  }
  get rootElement() {
    return this.getRootElement();
  }
  getRootElement() {
    return this._rootElem;
  }
  get model() {
    return this.getModel();
  }
  getModel() {
    return this._model;
  }
  /*******************************************/
  /* END COMPONENT RENDERER METHODS */
  /* START PRIVATE RENDER METHODS */
  /*******************************************/
  _renderNavigation() {
    this._renderGroupNavOptions();
    this._groupNavCmpnt.setSelectedValue(this.model.selectedGroup, true);

    this._renderPageNavOptions();
    this._pageNavCmpnt.setSelectedValue(this.model.selectedPage, true);
  }
  /*******************************************/
  /* END PRIVATE RENDER METHODS */
  /* START HANDLER METHODS */
  /*******************************************/
  _onShutdown() {
    this._shutdown();
  }
  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE API METHODS */
  /*******************************************/
  //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
  /*******************************************/
  /*  END PRIVATE API METHODS */
  /*******************************************/
}
module.exports = TwoTierLayoutRenderer;
